// import React, { useContext, useEffect, useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import axios from "axios";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { FaEye, FaEyeSlash, FaArrowRight } from "react-icons/fa"; // Imported FaArrowRight
// import InstallPrompt from "./InstallPrompt";
// import Image1 from "../../assets/login.webp";
// import image2 from "../../assets/loginlogo.png"
// const Login = () => {
//   const { login } = useContext(AuthContext);
//   const [user, setUser] = useState({ email: "", password: "" });
//   const [error, setError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);
//   const navigate = useNavigate();
//   const hasShownToast = React.useRef(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);
//     hasShownToast.current = false;

//     try {
//       const response = await axios.post(`${API_URL}/auth/login`, user, {
//         headers: { "Content-Type": "application/json" },
//       });

//       if (response.data.token && !hasShownToast.current) {
//         hasShownToast.current = true;
//         if (rememberMe) {
//           localStorage.setItem("email", user.email);
//           localStorage.setItem("password", user.password);
//           localStorage.setItem("rememberMe", true);
//         } else {
//           localStorage.removeItem("email");
//           localStorage.removeItem("password");
//           localStorage.setItem("rememberMe", false);
//         }
//         login(response.data.token);

//         toast.success(response.data.message, {
//           onClose: () => {
//             if (!response.data.warningMessage) {
//               navigate("/dashboard");
//             }
//           },
//         });

//         if (response.data.warningMessage) {
//           toast.warn(response.data.warningMessage, {
//             autoClose: 5000,
//             onClose: () => navigate("/dashboard"),
//           });
//         }
//       } else {
//         setError("Invalid email or password");
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const storedEmail = localStorage.getItem("email");
//     const storedPassword = localStorage.getItem("password");
//     const storedRememberMe = localStorage.getItem("rememberMe");

//     if (storedEmail && storedPassword && storedRememberMe) {
//       setUser({ email: storedEmail, password: storedPassword });
//       setRememberMe(true);
//     }
//   }, []);

//   const handleForgotPassword = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       if (!user.email) {
//         toast.error("Please enter your email address.");
//         return;
//       }

//       const response = await axios.post(
//         `${API_URL}/api/user/forgot-password`,
//         user.email,
//         {
//           headers: {
//             "Content-Type": "text/plain",
//           },
//         }
//       );

//       toast.success(response.data);
//     } catch (err) {
//       toast.error(err.response?.data);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="flex min-h-screen w-full bg-white">
//       {/* LEFT SECTION - IMAGE */}
//       <div className="hidden lg:flex lg:w-1/2 relative bg-gray-100 items-center justify-center">
//         <img
//           src={Image1}
//           alt="Login Banner"
//           className="absolute inset-0 w-full h-full object-cover"
//         />
//         <div className="absolute inset-0 bg-gradient-to-br from-blue-900/40 to-purple-900/40 mix-blend-multiply" />
//       </div>

//       {/* RIGHT SECTION - LOGIN FORM (Clean Professional UI) */}
//       <div className="w-full lg:w-1/2 flex flex-col justify-center items-center relative bg-white p-6 sm:p-12 lg:px-24">
        
//         {/* Logo Placeholder (Added as requested) */}
//         <div className="absolute top-8 left-8 sm:left-12 lg:left-4">
//           <img 
//             src={image2}
//             alt="The Cube Factory Logo Placeholder" 
//             className="h-14" 
//           />
//         </div>

//         <InstallPrompt />

//         <motion.div
//           className="w-full max-w-md z-10"
//           initial={{ opacity: 0, y: 15 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.5, ease: "easeOut" }}
//         >
//           <form
//             className="w-full"
//             onSubmit={forgotPasswordMode ? handleForgotPassword : handleSubmit}
//           >
//             {/* Header */}
//             <div className="mb-8 mt-12 sm:mt-0">
//               <h2 className="text-3xl font-bold text-gray-900 mb-2">
//                 {forgotPasswordMode ? "Reset Password" : "Welcome Back"}
//               </h2>
//               <p className="text-gray-500 text-sm">
//                 {forgotPasswordMode
//                   ? "Enter your email to reset your password"
//                   : "Please sign in to continue"}
//               </p>
//             </div>

//             {/* Error Message */}
//             {error && (
//               <div className="bg-red-50 text-red-500 p-3 rounded-lg mb-6 text-sm border border-red-100">
//                 {error}
//               </div>
//             )}

//             {/* Email Input */}
//             <div className="mb-5">
//               <label className="block text-gray-700 text-sm font-medium mb-1.5">
//                 Email Address
//               </label>
//               <input
//                 type="email"
//                 placeholder="Enter your email"
//                 className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all"
//                 onChange={(e) => setUser({ ...user, email: e.target.value })}
//                 value={user.email}
//                 required
//               />
//             </div>

//             {!forgotPasswordMode && (
//               <>
//                 {/* Password Input */}
//                 <div className="mb-5">
//                   <label className="block text-gray-700 text-sm font-medium mb-1.5">
//                     Password
//                   </label>
//                   <div className="relative">
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       value={user.password}
//                       placeholder="Enter your password"
//                       className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all pr-12"
//                       onChange={(e) =>
//                         setUser({ ...user, password: e.target.value })
//                       }
//                       required
//                     />
//                     <button
//                       type="button"
//                       className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
//                       onClick={() => setShowPassword(!showPassword)}
//                     >
//                       {showPassword ? (
//                         <FaEyeSlash size={18} />
//                       ) : (
//                         <FaEye size={18} />
//                       )}
//                     </button>
//                   </div>
//                 </div>

//                 {/* Remember Me & Forgot Password */}
//                 <div className="flex items-center justify-between mb-6">
//                   <label className="flex items-center cursor-pointer">
//                     <input
//                       type="checkbox"
//                       checked={rememberMe}
//                       onChange={() => setRememberMe(!rememberMe)}
//                       className="w-4 h-4 rounded border-gray-300 text-[#673AB7] focus:ring-[#673AB7] cursor-pointer"
//                     />
//                     <span className="ml-2 text-sm text-gray-600">
//                       Remember Me
//                     </span>
//                   </label>

//                   <button
//                     type="button"
//                     className="text-sm text-[#673AB7] hover:text-[#512DA8] font-semibold transition-colors underline"
//                     onClick={() => setForgotPasswordMode(true)}
//                   >
//                     Forgot Password?
//                   </button>
//                 </div>
//               </>
//             )}

//             {/* Submit Button */}
//             <button
//               type="submit"
//               disabled={loading}
//               className={`w-full py-3 bg-[#673AB7] text-white font-semibold rounded-lg transition-colors duration-300 ${
//                 loading ? "opacity-70 cursor-not-allowed" : ""
//               }`}
//             >
//               {loading ? (
//                 <div className="flex items-center justify-center gap-2">
//                   <svg
//                     className="animate-spin h-5 w-5 text-white"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     />
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                     />
//                   </svg>
//                   <span>Processing...</span>
//                 </div>
//               ) : forgotPasswordMode ? (
//                 "Send Reset Link"
//               ) : (
//                 "Sign In"
//               )}
//             </button>

//             {/* Back to Login Link */}
//             {forgotPasswordMode && (
//               <button
//                 type="button"
//                 className="mt-6 text-sm text-[#673AB7] hover:text-[#512DA8] font-semibold block mx-auto transition-colors"
//                 onClick={() => setForgotPasswordMode(false)}
//               >
//                 ← Back to Login
//               </button>
//             )}

//             {/* Sign Up & Website Links */}
//             {!forgotPasswordMode && (
//               <div className="mt-8 text-center space-y-2">
//                 <p className="text-sm text-gray-500">
//                   Don't have an account?{" "}
//                   <Link
//                     to="/register"
//                     className="text-[#673AB7] hover:text-[#512DA8] font-semibold transition-colors underline"
//                   >
//                     Sign up
//                   </Link>
//                 </p>
//                 <div className="text-sm text-gray-500 flex items-center justify-center gap-1">
//                   Go to{" "}
//                   <Link
//                     to="/"
//                     className="font-bold text-[#00AD8C] hover:text-[#008c73] transition-colors flex items-center gap-1"
//                   >
//                     Website <FaArrowRight size={12} />
//                   </Link>
//                 </div>
//               </div>
//             )}
//           </form>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default Login;






import React, { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash, FaArrowRight } from "react-icons/fa";
import InstallPrompt from "./InstallPrompt";
import Image1 from "../../assets/login.webp";
import image2 from "../../assets/loginlogo.png";

const Login = () => {
  const { login } = useContext(AuthContext);
  const [user, setUser] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const hasShownToast = React.useRef(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    hasShownToast.current = false;

    try {
      const response = await axios.post(`${API_URL}/auth/login`, user, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data.token && !hasShownToast.current) {
        hasShownToast.current = true;
        if (rememberMe) {
          localStorage.setItem("email", user.email);
          localStorage.setItem("password", user.password);
          localStorage.setItem("rememberMe", true);
        } else {
          localStorage.removeItem("email");
          localStorage.removeItem("password");
          localStorage.setItem("rememberMe", false);
        }
        login(response.data.token);

        toast.success(response.data.message, {
          onClose: () => {
            if (!response.data.warningMessage) {
              navigate("/dashboard");
            }
          },
        });

        if (response.data.warningMessage) {
          toast.warn(response.data.warningMessage, {
            autoClose: 5000,
            onClose: () => navigate("/dashboard"),
          });
        }
      } else {
        setError("Invalid email or password");
      }
    } catch (err) {
      toast.error(err.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedEmail = localStorage.getItem("email");
    const storedPassword = localStorage.getItem("password");
    const storedRememberMe = localStorage.getItem("rememberMe");

    if (storedEmail && storedPassword && storedRememberMe) {
      setUser({ email: storedEmail, password: storedPassword });
      setRememberMe(true);
    }
  }, []);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!user.email) {
        toast.error("Please enter your email address.");
        return;
      }

      const response = await axios.post(
        `${API_URL}/api/user/forgot-password`,
        user.email,
        {
          headers: {
            "Content-Type": "text/plain",
          },
        }
      );

      toast.success(response.data);
    } catch (err) {
      toast.error(err.response?.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    /* Changed min-h-screen to h-screen and added overflow-hidden to fix screen bounce */
    <div className="flex h-screen w-full bg-white overflow-hidden">
      
      {/* LEFT SECTION - IMAGE */}
      {/* Added h-full to respect parent height */}
      <div className="hidden lg:flex lg:w-1/2 relative bg-gray-100 items-center justify-center h-full">
        <img
          src={Image1}
          alt="Login Banner"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/40 to-purple-900/40 mix-blend-multiply" />
      </div>

      {/* RIGHT SECTION - LOGIN FORM (Clean Professional UI) */}
      {/* Added h-full and overflow-y-auto so short laptops can scroll the form smoothly */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center items-center relative bg-white p-6 sm:p-12 lg:px-24 h-full overflow-y-auto">
        
        {/* Logo Placeholder */}
        {/* Adjusted Z-index and responsive sizing slightly so it stays clean on small screens */}
        <div className="absolute top-6 left-6 sm:top-8 sm:left-12 lg:left-8 xl:left-12 z-20">
          <img 
            src={image2}
            alt="The Cube Factory Logo Placeholder" 
            className="h-10 sm:h-12 lg:h-14 w-auto" 
          />
        </div>

        <InstallPrompt />

        <motion.div
          /* Added mt-16 sm:mt-8 py-8 to give breathing room away from the logo when scrolling on small screens */
          className="w-full max-w-md z-10 mt-16 sm:mt-10 lg:mt-0 py-8"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <form
            className="w-full"
            onSubmit={forgotPasswordMode ? handleForgotPassword : handleSubmit}
          >
            {/* Header */}
            <div className="mb-8 mt-4 sm:mt-0">
              <h2 className="text-3xl font-bold text-gray-900 mb-2">
                {forgotPasswordMode ? "Reset Password" : "Welcome Back"}
              </h2>
              <p className="text-gray-500 text-sm">
                {forgotPasswordMode
                  ? "Enter your email to reset your password"
                  : "Please sign in to continue"}
              </p>
            </div>

            {/* Error Message */}
            {error && (
              <div className="bg-red-50 text-red-500 p-3 rounded-lg mb-6 text-sm border border-red-100">
                {error}
              </div>
            )}

            {/* Email Input */}
            <div className="mb-5">
              <label className="block text-gray-700 text-sm font-medium mb-1.5">
                Email Address
              </label>
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all"
                onChange={(e) => setUser({ ...user, email: e.target.value })}
                value={user.email}
                required
              />
            </div>

            {!forgotPasswordMode && (
              <>
                {/* Password Input */}
                <div className="mb-5">
                  <label className="block text-gray-700 text-sm font-medium mb-1.5">
                    Password
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={user.password}
                      placeholder="Enter your password"
                      className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#673AB7] focus:border-transparent text-gray-900 placeholder-gray-400 transition-all pr-12"
                      onChange={(e) =>
                        setUser({ ...user, password: e.target.value })
                      }
                      required
                    />
                    <button
                      type="button"
                      className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <FaEyeSlash size={18} />
                      ) : (
                        <FaEye size={18} />
                      )}
                    </button>
                  </div>
                </div>

                {/* Remember Me & Forgot Password */}
                <div className="flex items-center justify-between mb-6">
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={rememberMe}
                      onChange={() => setRememberMe(!rememberMe)}
                      className="w-4 h-4 rounded border-gray-300 text-[#673AB7] focus:ring-[#673AB7] cursor-pointer"
                    />
                    <span className="ml-2 text-sm text-gray-600">
                      Remember Me
                    </span>
                  </label>

                  <button
                    type="button"
                    className="text-sm text-[#673AB7] hover:text-[#512DA8] font-semibold transition-colors underline"
                    onClick={() => setForgotPasswordMode(true)}
                  >
                    Forgot Password?
                  </button>
                </div>
              </>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className={`w-full py-3 bg-[#673AB7] text-white font-semibold rounded-lg transition-colors duration-300 ${
                loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {loading ? (
                <div className="flex items-center justify-center gap-2">
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                  <span>Processing...</span>
                </div>
              ) : forgotPasswordMode ? (
                "Send Reset Link"
              ) : (
                "Sign In"
              )}
            </button>

            {/* Back to Login Link */}
            {forgotPasswordMode && (
              <button
                type="button"
                className="mt-6 text-sm text-[#673AB7] hover:text-[#512DA8] font-semibold block mx-auto transition-colors"
                onClick={() => setForgotPasswordMode(false)}
              >
                ← Back to Login
              </button>
            )}

            {/* Sign Up & Website Links */}
            {!forgotPasswordMode && (
              <div className="mt-8 text-center space-y-2">
                <p className="text-sm text-gray-500">
                  Don't have an account?{" "}
                  <Link
                    to="/register"
                    className="text-[#673AB7] hover:text-[#512DA8] font-semibold transition-colors underline"
                  >
                    Sign up
                  </Link>
                </p>
                <div className="text-sm text-gray-500 flex items-center justify-center gap-1">
                  Go to{" "}
                  <Link
                    to="/"
                    className="font-bold text-[#00AD8C] hover:text-[#008c73] transition-colors flex items-center gap-1"
                  >
                    Website <FaArrowRight size={12} />
                  </Link>
                </div>
              </div>
            )}
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Login;